import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GddcIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Gddc",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.98 2C9.12 2 3.55 7.56 3.55 14.42c0 2.41.69 4.66 1.87 6.56l-.03-.05h8.69l4.26-4.26v-4.21h-4.48l-4.01 4.05c-.22-.62-.34-1.34-.34-2.09 0-3.6 2.91-6.51 6.51-6.51s6.51 2.91 6.51 6.51c0 1.88-.8 3.58-2.07 4.77s-2.44 2.39-2.44 2.39V30l7.15-7.16c2.04-2.21 3.29-5.17 3.29-8.42C28.46 7.56 22.9 2 16.03 2h-.04Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16.2 0C8.36 0 2 6.35 2 14.19c0 2.75.79 5.33 2.14 7.5l-.03-.06h9.93l4.87-4.87v-4.81h-5.12l-4.58 4.63c-.25-.71-.39-1.53-.39-2.39 0-4.11 3.33-7.44 7.44-7.44s7.44 3.33 7.44 7.44c0 2.15-.91 4.09-2.37 5.45l-2.79 2.73v9.62l8.17-8.18c2.33-2.53 3.76-5.91 3.76-9.62C30.47 6.35 24.12 0 16.26 0z"
      })
    })
  }));
};
GddcIcon.displayName = 'GddcIcon';